import React from 'react';
import { Segment } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/elements/segment.less';

export default Segment;
